import React, { Fragment, useState } from 'react'
import { cloneDeep } from 'lodash-es'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { RadioButton } from '../forms/radio-button'
import Button from './button'
import ParameterAccordionItem from './parameter-accordion-item'
import IconFilters from '../../images/icon-filters.svg'
import useScreenSize from '../../utilities/useScreenSize'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import { YOU_FILTER, YOU_PARAMETER_ID } from '../../utilities/helpers'

const mapStateToProps = ({ survey: { showYourResults } }) => {
  return {
    showYourResults
  };
};

const ParameterFilter = ({
  filters,
  handleFiltersChange,
  respondentParameters,
  isAfterGameGuest,
  useTranslate,
  labelInside = false,
  showYourResults,
  disableYouParameter = false
}) => {

  const [selectedFilters, setSelectedFilters] = useState(cloneDeep(filters));
  
  const findParameterByValue = (array, value) => {
    for (let i = 0; i < array.length; i++) {
      if (array[i].value === value) {
        return array[i];
      }
      else if (array[i].children && array[i].children.length) {
        const result = findParameterByValue(array[i].children, value);
        // return the result only if it's actually found otherwise keep looping
        if(result) return result;
      }
    }
  };

  const [filtersOpen, setFiltersOpen] = useState(false);
  const screenSize = useScreenSize();

  let currentMainFilter = "everyone";
  if (selectedFilters.length > 0 && !selectedFilters.find((el) => (el.id === YOU_PARAMETER_ID))) {
    currentMainFilter = "parameters";
  } else if (selectedFilters.length === 1 && selectedFilters.find((el) => (el.id === YOU_PARAMETER_ID))) {
    currentMainFilter = "you";
  }

  const handleCurrentMainFilterChange = (val) => {
    if (val === "everyone") {
      setSelectedFilters([]);
    } else if (val === "you") {
      setSelectedFilters(YOU_FILTER);
    } else {
      setSelectedFilters( respondentParameters.map((param) => {
        return {
          "id": param.value,
          "values": []
        }
      }));
    }
  }

  const handleParameterChange = (add, paramId, parentId) => {
    let updatedArray = [...selectedFilters];

    if (add) {
      if(updatedArray.find((el) => el.id === parentId).values.findIndex(el => el === paramId) < 0) {
        updatedArray.find((el) => el.id === parentId).values.push(paramId);
        setSelectedFilters(updatedArray);
      }
    } else {
      updatedArray.find((el) => el.id === parentId).values = selectedFilters.find((el) => el.id === parentId).values.filter((el) => el !== paramId);
      setSelectedFilters(updatedArray);
    }
  }

  const handleCancelParameterChange = () => {
    setFiltersOpen(false);
    setSelectedFilters(cloneDeep(filters));
  }

  const handleConfirmParameterChange = () => {
    setFiltersOpen(false);
    setButtonText(getSelectedParameterNames());
    handleFiltersChange(selectedFilters);
  }

  const getParamNameByValue = (params, value) => {
    let found = false;
    for (let i = 0; i < params.length; i += 1) {
      if (params[i].value === value) {
        found = true;
        return params[i].label;
      }
      if (params[i].children && !found) {
        const foundName = getParamNameByValue(params[i].children, value);
        if (foundName) {
          return getParamNameByValue(params[i].children, value);
        }
      }
    }
  };

  const getSelectedParameterNames = () => {
    if (currentMainFilter !== "parameters") {
      return useTranslate(`data_vault.${currentMainFilter}`);
    } else {
      let paramNames = "";
      selectedFilters.forEach((param) => {
        param.values.forEach((value) => {
          paramNames += `${paramNames.length > 0 ? ", " : ""}${getParamNameByValue(respondentParameters, value)}`
        })
      })
      return paramNames;
    }
  };

  const [buttonText, setButtonText] = useState(getSelectedParameterNames());

  return (
    <Fragment>
      <ButtonContainer className="filters-container" onClick={()=>setFiltersOpen(true)}>
        {(!labelInside && screenSize.width < 1200) &&
          <label>{useTranslate("data_vault.show_dropdown_label")}</label>
        }
        <FiltersButton>
          <div className="filter-label">
            {(labelInside || screenSize.width >= 1200 )&& <span>{useTranslate("data_vault.show_dropdown_label")}:</span>}
            {buttonText}
          </div>
          <div className="filter-img">
            <img src={IconFilters} alt="Edit filters"/>
          </div>
        </FiltersButton>
      </ButtonContainer>
      {filtersOpen &&
        <FiltersPopup>
          <FiltersContainer>
            <div className="filters-header">
              <h4>{useTranslate("data_vault.filters_popup_header")}</h4>
              <button className="btn-close" onClick={() => handleCancelParameterChange()}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.55724 7.50002L15.7747 1.28252C15.8976 1.13904 15.9618 0.954484 15.9545 0.765727C15.9472 0.57697 15.869 0.397916 15.7354 0.264345C15.6018 0.130774 15.4228 0.0525242 15.234 0.0452334C15.0453 0.0379425 14.8607 0.102147 14.7172 0.225017L8.49974 6.44252L2.28224 0.217517C2.14101 0.0762892 1.94946 -0.00305176 1.74974 -0.00305176C1.55001 -0.00305176 1.35846 0.0762892 1.21724 0.217517C1.07601 0.358745 0.996667 0.550291 0.996667 0.750017C0.996667 0.949743 1.07601 1.14129 1.21724 1.28252L7.44224 7.50002L1.21724 13.7175C1.13872 13.7848 1.07496 13.8675 1.02994 13.9605C0.984924 14.0536 0.959627 14.1549 0.955637 14.2582C0.951647 14.3615 0.969051 14.4645 1.00676 14.5608C1.04446 14.657 1.10166 14.7444 1.17475 14.8175C1.24784 14.8906 1.33525 14.9478 1.43149 14.9855C1.52774 15.0232 1.63074 15.0406 1.73403 15.0366C1.83732 15.0326 1.93866 15.0073 2.03171 14.9623C2.12476 14.9173 2.2075 14.8535 2.27474 14.775L8.49974 8.55752L14.7172 14.775C14.8607 14.8979 15.0453 14.9621 15.234 14.9548C15.4228 14.9475 15.6018 14.8693 15.7354 14.7357C15.869 14.6021 15.9472 14.4231 15.9545 14.2343C15.9618 14.0455 15.8976 13.861 15.7747 13.7175L9.55724 7.50002Z" fill="black"/>
                </svg>
              </button>
            </div>
            <MainSelection>
              <div className="radio-selection">
                <RadioButton
                  checked={currentMainFilter === "everyone"}
                  value={"everyone"}
                  label={useTranslate("data_vault.everyone")}
                  name={"main-filter-selection"}
                  id={"everyone"}
                  onChange={(e) => handleCurrentMainFilterChange(e.target.value)}
                />
              </div>
              {!isAfterGameGuest &&
                <div className={`radio-selection ${!showYourResults || disableYouParameter ? "disabled" : ""}`}>
                  <RadioButton
                    checked={currentMainFilter === "you"}
                    value={"you"}
                    label={useTranslate("data_vault.you")}
                    name={"main-filter-selection"}
                    id={"you"}
                    onChange={(e) => handleCurrentMainFilterChange(e.target.value)}
                    disabled={!showYourResults || disableYouParameter}
                  />
                  {(!showYourResults && !disableYouParameter)  &&
                    <OverlayTrigger
                      placement={"top"}
                      overlay={
                        <Tooltip id="tt-detail">
                          {useTranslate("data_vault.you_parameter_info")}
                        </Tooltip>
                      }
                    >
                      <YouInfoButton>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="#F58220" xmlns="http://www.w3.org/2000/svg">
                          <path d="M9 5H11V7H9V5ZM9 9H11V15H9V9ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z" />
                        </svg>
                      </YouInfoButton>
                    </OverlayTrigger>
                  }
                </div>
              }
              {respondentParameters.length > 0 &&
                <div className="radio-selection">
                  <RadioButton
                    checked={currentMainFilter === "parameters"}
                    value={"parameters"}
                    label={useTranslate("data_vault.filters_popup_parameter_choice")}
                    name={"main-filter-selection"}
                    id={"parameter"}
                    onChange={(e) => handleCurrentMainFilterChange(e.target.value)}
                  />
                  {currentMainFilter === "parameters" && respondentParameters.map((param, index) => {
                    return (
                      <ParameterAccordionItem
                        parameterLabel={param.label}
                        parameterValue={param.value}
                        children={param.children}
                        selectedFilters={[...selectedFilters]}
                        handleParameterChange={handleParameterChange}
                        key={index}
                      />
                    )
                  })}
                </div>
              }
            </MainSelection>
          </FiltersContainer>
          <ButtonsContainer>
            <div>
              <Button
                kind={"orange"}
                onClick={() => handleConfirmParameterChange()}
                disabled={currentMainFilter === "parameters" && selectedFilters.every(param => param.values && param.values.length === 0)}
              >
                {useTranslate("data_vault.filters_popup_confirm_button")}
              </Button>
            </div>
            <div>
              <Button
                kind={"gray"}
                onClick={() => handleCancelParameterChange()}
              >
                {useTranslate("data_vault.filters_popup_cancel_button")}
              </Button>
            </div>
          </ButtonsContainer>
        </FiltersPopup>
      }
    </Fragment>
  )
}

export default connect(mapStateToProps)(ParameterFilter);

const ButtonContainer = styled.div`
  display: block;
  width: 100%;
  
  @media (min-width: 768px) {
    width: auto;
    min-width: 230px;
  }
  
  @media (min-width: 1200px) {

  }
`;

const FiltersButton = styled.div`
  height: 40px;
  background-color: #fff;
  border-radius: 10px;
  font-size: .875rem !important;
  border: 1px solid #EBE9E4;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 15px;
  cursor: pointer;
  
  .filter-label {
     white-space: nowrap;
     margin-right: 15px;
     white-space: nowrap;
     overflow: hidden;
     text-overflow: ellipsis;
     color: #000;
     span {
        font-size: 14px;
        font-weight: 500;
        margin-right: 7px;
        margin-bottom: 0;
     }
  }
  
  .filter-img {
    height: 100%;
    width: 50px;
    border-left: 1px solid #E6E9EF;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    
    img {
      transition: all .3s ease-in-out;
    }
  }
  
  &:hover {
    .filter-img img {
      filter: invert(54%) sepia(71%) saturate(685%) hue-rotate(344deg) brightness(97%) contrast(98%);
    }
  }
  
  @media (min-width: 992px) {
    height: 52px;
    padding-left: 20px;
    
    .filter-label {
      margin-right: 20px;
    }
  }
  
`;

const FiltersPopup = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100vh;
  max-width: 380px;
  background-color: #fff;
  box-shadow: 0px 2px 30px rgba(0, 0, 0, 0.1);
  z-index: 10;
  
  .filters-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem;
    border-bottom: 1px solid #E4E7EB;
    color: #000;
    background-color: #fafafa;
    
    h4 {
      margin: 0;
      max-width: 90%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  
  .btn-close {
    appearance: none;
    border: none;
    background: none;
    cursor: pointer;
    
    &:focus, &:active {
      outline: none;
    }
  }
`;

const FiltersContainer = styled.div`
  overflow: auto;
  max-height: calc(100vh - 100px);
`;

const MainSelection = styled.fieldset`
  .radio-selection {
    position: relative;
    padding: 1rem;
    border-bottom: 1px solid #E4E7EB;
    
    &.disabled {
      background-color: #fafafa;
      cursor: not-allowed;
    }
    
    &:last-of-type {
      border-bottom: none;
    }
  }
`;

const YouInfoButton = styled.div`
  position: absolute;
  right: 1rem;
  top: 50%;
  margin-top: -10px;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
`;

const ButtonsContainer = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 15px;
  padding: 1.5rem 1rem;
  border-top: 1px solid #E4E7EB;
  
  .engager-btn {
    width: 100%;
  }
`;



// WEBPACK FOOTER //
// ./src/components/ui/parameter-filter.js